<template>
  <div class="home-game bg-ui-panel grey100--text d-flex">
    <v-row align="center" no-gutters class="game-card-layout">
      <v-col cols="8" class="pl-5">
        <div class="game-info mb-1">
          <h3 class="text-uppercase grey100--text text-h6 font-weight-bold">
            Crate Unboxing
          </h3>
          <p class="text--secondary text-body-1">
            Exciting Rust item unboxing
          </p>
        </div>


        <h5 class="game-stats text-body-1 text--secondary d-flex align-center">
          <scrap :amount="won" class="mr-2 text--secondary" /> unboxed
        </h5>
      </v-col>

      <v-col cols="4">
        <v-img
          class="case"
          :src="img" contain
          width="90%" aspect-ratio="1"
        />

        <div class="rust-items">
          <v-img
            v-for="(item, i) in items"
            :key="i"
            class="case-item"
            :class="`item--${i + 1}`"
            :src="item" contain
            aspect-ratio="1"
          />
        </div>
      </v-col>
    </v-row>

    <div v-if="xpBonus > 1" class="xp-bonus px-2 py-2 font-weight-bold lh-1 text-caption green700 green200--text">
      +{{ (xpBonus - 1) * 100 | toLocale }}% XP
    </div>
  </div>
</template>

<script>
const defaultCaseImg = require('@/assets/img/games/cases/default-case.png')

const ITEMS = [
  'https://community.cloudflare.steamstatic.com/economy/image/6TMcQ7eX6E0EZl2byXi7vaVKyDk_zQLX05x6eLCFM9neAckxGDf7qU2e2gu64OnAeQ7835Fe5GLEfCk4nReh8DEiv5daPq0_qrw_QfG9O-tu0Dw/164x164',
  'https://community.cloudflare.steamstatic.com/economy/image/6TMcQ7eX6E0EZl2byXi7vaVKyDk_zQLX05x6eLCFM9neAckxGDf7qU2e2gu64OnAeQ7835Ff5GLNfCk4nReh8DEiv5dbPK47pbcyR_m4DQ68Ofs/164x164',
  'https://community.cloudflare.steamstatic.com/economy/image/6TMcQ7eX6E0EZl2byXi7vaVKyDk_zQLX05x6eLCFM9neAckxGDf7qU2e2gu64OnAeQ7835Fe4WLMfCk4nReh8DEiv5dbO6o7rrMwQPy59FTZYoM/164x164',
]
export default {
  props: {
    stats: {
      type: Object,
      default: null,
    },
    conga: {
      type: Object,
      default: null,
    },
  },
  computed: {
    opened() {
      return this.stats?.opened ?? 0
    },
    won() {
      return this.stats?.won ?? 0
    },
    xpBonus() {
      return this.conga?.games.cases.xpMultiplier ?? 1
    },
    items() {
      return ITEMS
    },
    img() {
      return defaultCaseImg
    },
  },
}
</script>

<style lang="scss" scoped>
.home-game {
  position: relative;
  height: 160px;
  cursor: pointer;
  transition: transform 0.3s ease;

  .game-card-layout {
    overflow: hidden;
    position: relative;
  }

  .case {
    transition: transform 0.8s ease;
  }

  .game-info,
  .game-stats {
    transition: transform 0.6s ease;
  }

  .xp-bonus {
    position: absolute;
    z-index: 3;
    top: 0;
    right: 0;
    background: gold;
    transform: translate(20%, -50%) rotate(-3deg);
  }

  .rust-items {
    @include overlay;

    pointer-events: none;

    .case-item {
      position: absolute;
      width: 20%;
      max-width: 100px;
      opacity: 0;
      transition: transform 0.5s ease, opacity 0.5s ease;

      &.item--1 {
        z-index: 3;
        top: 10%;
        right: 15%;
        transition-delay: 0.2s;
        transform: translateY(30%) translateX(10%) scale(0.8);
      }

      &.item--2 {
        top: 5%;
        right: 5%;
        transition-delay: 0.1s;
        transform: translateY(20%) translateX(30%) scale(0.8);
      }

      &.item--3 {
        top: 20%;
        right: 30%;
        transform: translateY(35%) translateX(-20%) scale(0.8);
      }
    }
  }

  &:hover {
    transform: translateY(-3px);

    .case {
      transform: translate(20px, 40px) rotate(-4deg) scale(1.15);
    }

    .rust-items .case-item {
      opacity: 1;
      transform: translateY(0) translateX(0) scale(1);
    }

    .game-info {
      transform: translateX(24px) rotate(2deg) scale(1.1);
    }

    .game-stats {
      transform: translateX(24px) rotate(2deg) scale(1.1);
    }
  }
}
</style>
